import { StreamHandler } from "./stream.handler";
import { SubscribeCampaignProgress, UpdateCampaignProgress } from "@/types";
import type { CampaignProgressSchema } from "@/types";
import { useAppStore } from "@/stores";
import { recomputeAssembledCampaigns } from "@/stores/derive";

/**
 * `campaign_progress` — the type-agnostic per-player stream carrying opt-in
 * (`joined`) state for every served campaign type, and the player's own end of
 * a limited-time campaign (`ends_at`). Feeds `joinedById`, which consumers read
 * directly; an `ends_at` lands on the campaign's `end`, so the assembled views
 * are re-derived when one moves.
 */
export class CampaignProgressHandler extends StreamHandler<CampaignProgressSchema[]> {
  protected readonly subscribeType = SubscribeCampaignProgress;
  protected readonly updateType = UpdateCampaignProgress;

  protected isBusy(): boolean {
    const s = useAppStore.getState().campaignProgressStream;
    return s.subscribed || s.loading;
  }
  protected setLoading(loading: boolean): void {
    useAppStore.getState().setCampaignProgressLoading(loading);
  }
  protected setSubscribed(subscribed: boolean): void {
    useAppStore.getState().setCampaignProgressSubscribed(subscribed);
  }
  protected clear(): void {
    useAppStore.getState().clearCampaignProgress();
  }
  protected apply(data: CampaignProgressSchema[]): void {
    const before = useAppStore.getState().campaignsById;
    useAppStore.getState().setCampaignProgress(data);
    if (useAppStore.getState().campaignsById !== before) {
      recomputeAssembledCampaigns();
    }
  }
}

export const campaignProgressHandler = new CampaignProgressHandler();
